export const ERROR_CODE_EXPIRED_ACTIVATION_LINK = -1034;
export const ERROR_CODE_ALREADY_REGISTERED = -1030;

export const MESSAGE_NO_AGENT = 'Please use a valid link with a promocode to register under your agent.';
export const MESSAGE_WRONG_PROMO_CODE = 'Invalid promocode.';
export const MESSAGE_NO_MIGRATION_PARAM = 'migration_param should be provided.';
export const MESSAGE_EMAIL_INVALID_FORMAT = 'Invalid email format';

export const PAGE_SHOP_PROMOCODE = '/Shop';
export const PAGE_REGISTRATION_THANK_YOU= '/Shop/thank-you';
export const PAGE_REGISTRATION_FAILED = '/Shop/failed';
export const PAGE_PROMO_CODE_FAILED= '/Shop/invalid-promo-code';
export const PAGE_SHOP = '/registration/registration/shop';
export const PAGE_SHOP_THANK_YOU = '/registration/Registration/Shop/activation-success';
export const PAGE_SHOP_FAILED = '/registration/Registration/Shop/failed';
export const PARAM_EMAIL = 'email';
export const PARAM_MOBILE = 'mobile';
export const PARAM_MAIL_FROM = 'mail@bet9ja.com';

export const SERVER_CDN_PATH = server.cdnPath;
export const SERVER_HEADER_MENU = server.headerMenu;
export const SERVER_LINKS = server.links;
export const SERVER_STATES = server.states;
export const FORM_CONSTRAINTS = server.formConstraints;

export const API_FE_DOMAIN = server.ajaxEndpoints.uri;
export const API_FE_VALIDATE_AGENT_PROMOTION = server.ajaxEndpoints.validateAgentPromotion.uri;
export const API_FE_VALIDATE_MOBILE = server.ajaxEndpoints.validateMobile.uri;
export const API_FE_VALIDATE_FORM = server.ajaxEndpoints.validateForm.uri;
export const API_FE_SUBMIT_CLIENT_FROM_SHOP = server.ajaxEndpoints.submitClientFromShop.uri;
export const API_FE_SEND_RECOVERY_PASSWORD = server.ajaxEndpoints.sendRecoveryPassword.uri;
export const API_FE_DELETE_LOGIPARMA_DORMANT_CLIENT = server.ajaxEndpoints.deleteLogiParmaDormantClient.uri;
export const API_FE_DELETE_BOLT_DORMANT_CLIENT = server.ajaxEndpoints.deleteBoltDormantClient.uri;
export const API_FE_GET_USER_AND_INACTIVE_INFO = server.ajaxEndpoints.getUserAndInactiveInfo.uri;
